(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kefo-ai-back-in-stock"] && !Shopify.designMode) return;
  try {
    class KefoAiBackInStock extends HTMLElement {
    #abort;

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.variantIds = new Set((this.dataset.variantIds || '').split(','));
      this.form = this.querySelector('[data-kefo-ai-form]');
      this.successBox = this.querySelector('[data-kefo-ai-success]');
      this.errorBox = this.querySelector('[data-kefo-ai-error]');
      this.submitButton = this.querySelector('[data-kefo-ai-submit]');
      document.addEventListener('variant:change', (event) => this.onVariantChange(event), { signal });
      this.form.addEventListener('submit', (event) => this.onSubmit(event), { signal });
      this.render();
    }

    disconnectedCallback() {
      this.#abort?.abort();
    }

    onVariantChange(event) {
      const detail = event.detail || {};
      const variant = detail.variant;
      if (variant) {
        if (!this.variantIds.has(String(variant.id))) return;
        this.dataset.variantId = String(variant.id);
        this.dataset.variantTitle = variant.title || '';
        this.hidden = Boolean(variant.available);
      } else if (String(detail.formId || '').includes(`-${this.dataset.productId}-`)) {
        this.hidden = true;
      } else {
        return;
      }
      this.render();
    }

    render() {
      this.querySelectorAll('[data-kefo-ai-variant]').forEach((element) => {
        element.textContent = this.dataset.variantTitle;
      });
      const subscribed = this.dataset.variantId in this.subscribedVariants();
      this.form.hidden = subscribed;
      this.successBox.hidden = !subscribed;
      this.showError('');
    }

    // { variantId: signedUpAtMs } — a signup is remembered for 30 days only,
    // so the form comes back once the email went out and the size sold out again.
    subscribedVariants() {
      const maxAgeMs = 30 * 24 * 60 * 60 * 1000;
      try {
        const stored = JSON.parse(localStorage.getItem('kefo-ai-back-in-stock') || '{}');
        if (!stored || typeof stored !== 'object' || Array.isArray(stored)) return {};
        return Object.fromEntries(
          Object.entries(stored).filter(([, at]) => typeof at === 'number' && Date.now() - at < maxAgeMs),
        );
      } catch {
        return {};
      }
    }

    rememberVariant(variantId) {
      try {
        const entries = Object.entries({ ...this.subscribedVariants(), [variantId]: Date.now() }).slice(-50);
        localStorage.setItem('kefo-ai-back-in-stock', JSON.stringify(Object.fromEntries(entries)));
      } catch {}
    }

    showError(message) {
      this.errorBox.textContent = message;
      this.errorBox.hidden = !message;
    }

    async onSubmit(event) {
      event.preventDefault();
      const { email, website } = this.form.elements;
      email.value = email.value.trim();
      if (!email.value || !email.checkValidity()) {
        this.showError(this.dataset.errorEmail);
        email.focus();
        return;
      }

      const variantId = this.dataset.variantId;
      this.showError('');
      this.submitButton.disabled = true;
      this.submitButton.setAttribute('aria-busy', 'true');

      try {
        // kefo reads only these fields; titles and SKU come from Shopify.
        const response = await fetch(this.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            shop: this.dataset.shop,
            locale: this.dataset.locale,
            productId: this.dataset.productId,
            variantId,
            email: email.value,
            website: website.value,
          }),
          signal: AbortSignal.timeout(10000),
        });
        const messageFor = { 429: 'errorRate', 410: 'errorGone', 409: 'errorAvailable' }[response.status];
        if (messageFor) {
          this.showError(this.dataset[messageFor]);
          return;
        }
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        this.rememberVariant(variantId);
        this.render();
        this.successBox.focus();
      } catch {
        this.showError(this.dataset.errorGeneric);
      } finally {
        this.submitButton.disabled = false;
        this.submitButton.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('kefo-ai-back-in-stock')) {
    customElements.define('kefo-ai-back-in-stock', KefoAiBackInStock);
  }
  } catch(e) { console.error(e); }
})();

})();
